var render = function render(){var _vm=this,_c=_vm._self._c;return _c('q-select',{attrs:{"value":_vm.$i18n.locale,"options":_vm.options,"emit-value":"","map-options":"","square":"","borderless":"","dense":""},on:{"input":_vm.onInput}})
}
var staticRenderFns = []

export { render, staticRenderFns }